module.exports = __webpack_public_path__ + "static/media/persevering-face-svgrepo-com.be52b1db.svg";